package org.example.site_web.content.page


val whoWeAreContent_Part1:String = "Accelarge Innovations est une jeune société d’ingénierie "+
        "fondée en 2025 par Pierre DANIEAU, "+
        "ingénieur généraliste ayant exercé pendant 18 années "+
        "dans les domaines de l'énergie nucléaire, la vision industrielle et l'instrumentation connectée."

val whoWeAreContent_Part2:String = "Passionnés et fort d’expériences d'expériences "+
        "en recherche et développement ainsi qu'en projets industriels, "+
        "nous mettons aujourd’hui nos compétences au service des TPE et petites PME pour "+
        "accompagner leurs croissance grâce à une transformation technologique accessible, rentable et pérenne."